import { ENDPOINTS } from 'config/endpoints';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import CronoError from 'crono-fe-common/types/error';
import client from 'utils/clients/client';
import { Request } from 'crono-fe-common/types/request';

export type CalendarType = 'Google' | 'Outlook';

export type CalendarDisconnectReason =
  | 'Expired'
  | 'DisconnectedByUser'
  | 'Revoked';

export type CalendarIntegration = {
  email: string | null;
  type: CalendarType | null;
  disconnectReason: CalendarDisconnectReason | null;
  default: boolean;
  displayName: string | null;
};

export type GetCalendarResult = {
  data: { isSuccess: boolean; data: CalendarIntegration[] | null };
};

export const CALENDAR_QUERY_KEY = ENDPOINTS.calendar.main;

export const invalidateGetCalendar = (
  queryClient: ReturnType<typeof useQueryClient>,
) => {
  queryClient.invalidateQueries([CALENDAR_QUERY_KEY]);
};

const useGetCalendar = (withVerify?: boolean) => {
  const queryString = withVerify ? '?withVerify=true' : '';

  const request: Request = {
    url: ENDPOINTS.calendar.main + queryString,
    config: { method: 'GET' },
  };

  return useQuery<GetCalendarResult, CronoError>(
    [CALENDAR_QUERY_KEY, withVerify],
    () => client(request),
  );
};

export default useGetCalendar;
